import { Flex } from "antd";
import { useFetchAgencyQuery } from "features/basicInfo/agencyPortal/agencySettingsAPI";
import { useLazyFetchSettingQuery } from "features/messages/internalMessagingApi";
import { useEffect, useState } from "react";
import { StreamChat } from "stream-chat";
import { Chat } from "stream-chat-react";
import styled from "styled-components";

const ContentWrapper = styled(Flex)`
  // height: calc(100vh - 80px);
  // display: flex;
  // flex-direction: column;
`;

function InternalMessagingProvider({ children, userType }) {
  const [client, setClient] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [fetchSetting] = useLazyFetchSettingQuery();
  const { data: agency } = useFetchAgencyQuery(
    {},
    {
      skip: userType !== "agency",
    },
  );

  useEffect(() => {
    const initialize = async () => {
      const settingResult = await fetchSetting();
      const setting = settingResult?.data;

      if (
        !setting ||
        !setting?.isEnabled ||
        !setting?.isConfigured ||
        !setting?.token ||
        !setting?.extUserId ||
        isInitialized
      ) {
        return "pending";
      }

      try {
        const newClient = StreamChat.getInstance(setting?.apiKey);

        if (!newClient.user) {
          await newClient.connectUser(
            {
              id: setting?.extUserId,
            },
            setting?.token,
          );
        }

        setClient(newClient);
        setIsInitialized(true);
        return "success";
      } catch (error) {
        console.error("Failed to initialize Stream Chat client:", error);
        return "error";
      }
    };

    if (agency?.isInternalMessagingEnabled) {
      initialize();
    }
  }, [isInitialized, agency?.isInternalMessagingEnabled, fetchSetting]);

  if (!agency?.isInternalMessagingEnabled || !isInitialized) {
    return (
      <ContentWrapper vertical>
        <div className="app__wrapper">{children}</div>
      </ContentWrapper>
    );
  }

  // Only render Chat provider when client is properly initialized
  return (
    <ContentWrapper vertical>
      <div className="app__wrapper str-chat">
        <Chat client={client} theme="team light">
          {children}
        </Chat>
      </div>
    </ContentWrapper>
  );
}

export default InternalMessagingProvider;
